import UnmatchedFilesTable from './UnmatchedFilesTable';

const UnmatchedFilesSection = () => {
  return <UnmatchedFilesTable />;
};

export default UnmatchedFilesSection;
